var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2897_454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 49.5455C38.5566 49.5455 49.546 38.5561 49.546 25C49.546 11.444 38.5566 0.45459 25.0005 0.45459C11.4445 0.45459 0.455078 11.444 0.455078 25C0.455078 38.5561 11.4445 49.5455 25.0005 49.5455Z",
    fill: "white",
    stroke: "#E1E1E2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4208 28.9301L13.0979 33.9569L8.26268 34.061C6.81768 31.3329 5.99805 28.2118 5.99805 24.8949C5.99805 21.6876 6.76437 18.663 8.12277 15.9998H8.12377L12.4285 16.8031L14.3142 21.1583C13.9195 22.3295 13.7044 23.5867 13.7044 24.8949C13.7045 26.3147 13.9572 27.6751 14.4208 28.9301Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6707 21.2817C43.889 22.4518 44.0027 23.6601 44.0027 24.8951C44.0027 26.2798 43.8597 27.6306 43.5872 28.9335C42.6622 33.3672 40.2451 37.2388 36.8967 39.9785L36.8956 39.9775L31.4737 39.6959L30.7063 34.82C32.9282 33.4937 34.6645 31.4181 35.5792 28.9335H25.418V21.2817H35.7274H43.6707Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8949 39.9773L36.896 39.9784C33.6395 42.6426 29.5028 44.2368 24.9996 44.2368C17.763 44.2368 11.4713 40.1197 8.26172 34.061L14.4198 28.9302C16.0245 33.2895 20.156 36.3927 24.9996 36.3927C27.0815 36.3927 29.0319 35.8199 30.7055 34.8198L36.8949 39.9773Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1301 10.0061L30.9741 15.1359C29.242 14.0339 27.1945 13.3972 25.0009 13.3972C20.0477 13.3972 15.8389 16.6428 14.3145 21.1585L8.12409 15.9999H8.12305C11.2856 9.79354 17.6567 5.55322 25.0009 5.55322C29.6116 5.55322 33.8391 7.2249 37.1301 10.0061Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2897_454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.5324e1a6ecbcf2760e71e2fc2e52fb4a.svg";
export { ForwardRef as ReactComponent };